import { createContext } from "react";

/**
 * Signed-in user identity derived from the MSAL account. Authentication only —
 * no roles/permissions are modelled here.
 */
export interface AuthUser {
  /** MSAL localAccountId (stable per user per tenant). */
  id: string;
  /** UPN / username (used as the email). */
  email: string;
  /** Display name from the id token, if present. */
  displayName?: string;
  /** Entra tenant id. */
  tenantId?: string;
}

export interface AuthContextValue {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  /** Start the Entra redirect sign-in flow. */
  login: () => void;
  /** Full redirect sign-out. */
  logout: () => Promise<void>;
  /** Best-effort silent sign-out (used by the idle timeout). */
  silentLogout: () => Promise<void>;
  /**
   * Two-letter initials for the avatar (e.g. "JD" for "John Doe"): first
   * letters of the first and last name parts, falling back to the email.
   */
  getInitials: () => string;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
